<template>
  <i :class="iconClass" :ds-component="`DsIcon-${name}`"></i>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'DsIcon',
  props: {
    name: {
      type: String
    },
    size: {
      type: String,
      default: 'default'
    },
    space: {
      type: String
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClass() {
      return [
        'ds-icon',
        this.name ? `ds-icon--${this.name}` : '',
        `ds-icon--size-${this.size}`,
        this.space ? `ds-icon--space-${this.space}` : ''
      ];
    }
  },
  mounted() {
    // @ts-ignore
    document.documentElement.setAttribute('data-color-theme', this.dark ? 'dark' : '');
  }
});
</script>

<style lang="scss" scoped>
@import './Icons.scss';
</style>
